"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Checkbox_1 = require("./Checkbox");
exports.default = Checkbox_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Checkbox/index.js
// module id = 235
// module chunks = 8